import { render, staticRenderFns } from "./ShiftRequirementEdit.vue?vue&type=template&id=2771c2ab"
import script from "./ShiftRequirementEdit.js?vue&type=script&lang=js&external"
export * from "./ShiftRequirementEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports